import PageContent from './components/PageContent'

const CustomDeadLines = () => (
  <PageContent />
)

export default CustomDeadLines
